import Axios from '@/lib/request'
import ax from '@/lib/requestTms'
const LOP_SRT = `?LOP-DN=${process.env.VUE_APP_GW_DOMAIN_HTTP}`
const LOP_SRT_JSF = `?LOP-DN=${process.env.VUE_APP_GW_DOMAIN}`
const duccHeaders = {
  application: process.env.VUE_APP_DUCC_APPLICATION,
  token: process.env.VUE_APP_DUCC_TOKEN
}
// 通用环境
const duccEnv = process.env.VUE_APP_DUCC_ENV
const TMSAPI = {
  // 行驶轨迹页-查询轨迹
  queryDrivingTrack: (params: any) => Axios.post(`/ts/overseas/transTask/queryDrivingTrack${LOP_SRT_JSF}`, params),
  // 行驶轨迹页-查询轨迹/api-itms/overseas/transTask/queryTaskDrivingInfo
  queryTaskSiteList: (params: any) => Axios.post(`/ts/overseas/transTask/queryTaskDrivingInfo${LOP_SRT_JSF}`, params),
  // 路径替换成自己的ducc配置路径
  getPageSpyWhiteList() {
    return ax.get(`/ducc/v1/namespace/jdl_ife/config/ife/profile/${duccEnv}/item/itmsPageSpyWhiteList`, {
      headers: duccHeaders
    })
  }
}

export default TMSAPI
